import { render } from "./sample-image-carousel.vue?vue&type=template&id=01ec9eab&scoped=true"
import script from "./sample-image-carousel.vue?vue&type=script&lang=js"
export * from "./sample-image-carousel.vue?vue&type=script&lang=js"

import "./sample-image-carousel.vue?vue&type=style&index=0&id=01ec9eab&lang=scss&scoped=true"

import exportComponent from "/tmp/build_ed238492/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01ec9eab"]])

export default __exports__